import { Component, OnInit, ViewChild } from "@angular/core";
import { AppMemoryService } from "./../../core/app-memory.service";
import { GetService } from "../../core/get.service";
import { NotificationsService } from "angular2-notifications";
import { Subscription } from "rxjs/Subscription";
import { TranslateService } from "@ngx-translate/core";
import { environment } from "environments/environment";
import { TooltipComponent } from "../../core/tooltip/tooltip.component";
import { Router } from "@angular/router";

@Component({
  selector: "app-info",
  templateUrl: "./info.component.html",
  styleUrls: ["./info.component.less"],
})
export class InfoComponent implements OnInit {
  public allSelected: Boolean = false;

  public vat: number;
  public address1: string;
  public city: string;
  public state: string;
  public country: number;
  public countries: any[];
  public countriesSub: Subscription;
  public user$: Subscription;
  public user: User;

  public currentLang: Array<Object> = [];

  public languages = [
    {
      id: "" as string,
      text: "" as string,
    },
  ];

  public serverError = null;
  public isRequestInProgress = false;
  public isRequestSuccess = false;

  public translation = {};

  public _languages = environment.languages || [];
  public isShowTooltip: boolean;
  @ViewChild("inviteUserTutorial") tooltip: TooltipComponent;

  constructor(
    public appMemory: AppMemoryService,
    public getService: GetService,
    private notificationsService: NotificationsService,
    public translate: TranslateService,
    private router: Router
  ) {
    const user$ = this.appMemory.userSubject.subscribe((e) => {
      if (this.appMemory.user && e) {
        this.setUser(this.appMemory.user);
      }
    });
    this.getTranslation();
  }

  ngOnInit(): void {
    this.countriesSub = this.appMemory.countries.subscribe((countries) => {
      if (countries) {
        countries.forEach((e) => {
          e.text = e.name;
        });

        this.countries = countries;
      }
    });
  }

  setUser(user: any) {
    this.user = user;

    //console.log(user);

    this.vat = this.user.vat;
    this.address1 = this.user.address1;
    this.city = this.user.city;
    this.state = this.user.state;
  }

  objectToArray(obj: Object) {
    return Object.keys(obj).map((key) => obj[key]); // transform Array-like Object to Array
  }

  changeInfo(form: any) {
    this.serverError = null;
    this.isRequestSuccess = false;

    if (form.form.invalid) {
      console.log("Form invalid!");
      return;
    }

    const body = {
      vat: this.vat,
      address1: this.address1,
      city: this.city,
      state: this.state,
      country: this.country[0]["id"],
    };

    this.isRequestInProgress = true;
    this.getService.changeInfo(body).then(
      (res: any) => {
        this.isRequestInProgress = false;
        this.appMemory.user.vat = this.vat;
        this.appMemory.user.address1 = this.address1;
        this.appMemory.user.city = this.city;
        this.appMemory.user.state = this.state;
        this.appMemory.user.country = this.country[0]["id"];
        this.isRequestSuccess = true;

        this.notificationsService.success(
          `${this.translation["changeVat"]}`,
          `${this.translation["VATChanged"]}`
        );
      },
      (err: any) => {
        console.log("THIS.SERVERERROR", this.serverError);
        this.isRequestInProgress = false;
        this.isRequestSuccess = false;
        this.notificationsService.error(
          `${this.translation["changeVat"]}`,
          `${this.translation["errorOccurred"]}`
        );
        this.serverError = this.objectToArray(JSON.parse(err._body));
      }
    );
  }

  getTranslation() {
    this.translate.get("PROFILE.changeVat").subscribe((word: string) => {
      this.translation["changeVat"] = word;
    });
    this.translate.get("PROFILE.VATChanged").subscribe((word: string) => {
      this.translation["VATChanged"] = word;
    });
  }

  goToProfile() {
    this.router.navigateByUrl("/profile");
  }

  goToInvoices() {
    this.router.navigateByUrl("/invoices");
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/custom/info/info.component.ts